import type { DeclarationOfConformityGen4 } from '../content';

export const declarationOfConformityGen4Data: DeclarationOfConformityGen4[] = [
  {
    equipment: 'eu_declaration_equipment_ring',
    modelType: 'eu_declaration_type_OA11',
    productImage: 'blue-sky/eu-declaration-of-conformity/eu-doc-oa11-ring',
    directives: [
      'eu_declaration_directive_2014',
      'eu_declaration_directive_2011',
    ],
    technicalSpecifications: [
      {
        title: 'eu_declaration_article_3_1_a_safety',
        description: ['EN 62368-1:2020'],
      },
      {
        title: 'eu_declaration_article_3_1_a_emf',
        description: ['EN 62479:2010'],
      },
      {
        title: 'eu_declaration_article_3_1_b_emc',
        description: [
          'EN 301 489-1 V2.2.3',
          'EN 301-489-3 V2.3.2',
          'Draft EN 301 489-17 V3.2.6',
          'EN 55011:2016 + A11:2020 + A2:2021',
          'EN 61000-6-1:2019',
          'EN 61000-6-3:2021',
        ],
      },
      {
        title: 'eu_declaration_article_3_2_radio',
        description: ['EN 300 328 V2.2.2', 'EN 303 417 V1.1.1'],
      },
    ],
    signedBy: {
      date: 'eu_declaration_signed_behalf',
      signatureImage:
        'blue-sky/eu-declaration-of-conformity/jyri-suokas-signature',
      name: 'Jyri Suokas',
      position: 'eu_declaration_jyri_title',
    },
  },
  {
    equipment: 'eu_declaration_equipment_charger',
    modelType: 'eu_declaration_type_OA12',
    productImage: 'blue-sky/eu-declaration-of-conformity/eu-doc-oa12-charger',
    directives: [
      'eu_declaration_directive_2014',
      'eu_declaration_directive_2011',
    ],
    technicalSpecifications: [
      {
        title: 'eu_declaration_article_3_1_a_safety',
        description: ['EN 62368-1:2020'],
      },
      {
        title: 'eu_declaration_article_3_1_a_emf',
        description: ['EN 62311:2008'],
      },
      {
        title: 'eu_declaration_article_3_1_b_emc',
        description: [
          'EN 301 489-1 V2.2.3',
          'EN 301-489-3 V2.3.2',
          'EN 55011:2016 + A11:2020 + A2:2021',
          'EN 61000-6-1:2019',
          'EN 61000-6-3:2021',
        ],
      },
      {
        title: 'eu_declaration_article_3_2_radio',
        description: ['EN 303 417 V1.1.1'],
      },
    ],
    signedBy: {
      date: 'eu_declaration_signed_behalf',
      signatureImage:
        'blue-sky/eu-declaration-of-conformity/jyri-suokas-signature',
      name: 'Jyri Suokas',
      position: 'eu_declaration_jyri_title',
    },
  },
];
